// (function() {
//   const add = '@nw'
//   const tags = [
//     { tag: 'description', prop: 'name' },
//     { tag: 'og:description', prop: 'property' }
//   ]

//   tags.forEach(({ tag, prop }) => {
//     console.log($(`meta[${prop}="${tag}"]`).attr('content'))

//     if($(`meta[${prop}="${tag}"]`).attr('content').includes(add)) {
//       const newContent = $(`meta[${prop}="${tag}"]`).attr('content').substr(0, $(`meta[${prop}="${tag}"]`).attr('content').indexOf(add))

//       $(`meta[${prop}="${tag}"]`).attr('content', newContent)
//     }
//   })

// })()


// email settings
const emailSetting = {
  USER_ID: 'user_tpatRAuFjTL5OlaBGsXC8',
  SERVICE_ID: 'primary',
  TEMPLATE_NEWSLETTER: 'template_woz18od',
  TEMPLATE_ZIPCODE: 'template_6fkqfj9'
}

emailjs.init(emailSetting.USER_ID)

if (window.location.pathname === '/pages/contacto') {
  
  
    $('.content-layout-wrapper').css('padding', '0 10px');
  	$('.content-layout-wrapper h1').css('display', 'none');
  	$($('.rte .dt-sc-contact-info')[0]).css('display', 'none')
    $('.page-title').css('margin-bottom', '0')
    
    
    var redIcon = new L.Icon({
      iconUrl: 'https://cdn.rawgit.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    
   	
    $('<div id="_map"></div>').insertAfter('.page-title')
    
    var map = L.map('_map').
     setView([19.30139554,-99.165746], 17
     );
    
  	L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
		maxZoom: 20,
    	subdomains:['mt0','mt1','mt2','mt3']
		}).addTo(map);
  	
	L.marker([19.30139554,-99.165746], {
      draggable: false,
      icon: redIcon}
     )
    .bindTooltip("Duduk De ABRÍC", 
    {	
      	className: 'map-bind-name',
        permanent: true, 
        direction: 'right'
    }).addTo(map)

}


// ##############################################################################

$('<span class="mdi mdi-chair-rolling"></span>').insertBefore('#menu-item-1595468835155 .woodmart-nav-link span')

$('<span class="mdi mdi-table-furniture"></span>').insertBefore('#menu-item-1595443259284 .woodmart-nav-link span')

$('<span class="mdi mdi-bed-king-outline"></span>').insertBefore('#menu-item-1595443418121 .woodmart-nav-link span')

$('<span class="mdi mdi-bunk-bed-outline"></span>').insertBefore('#menu-item-1568672747874 .woodmart-nav-link span')

$('<span class="mdi mdi-table-chair"></span>').insertBefore('#menu-item-1568657896672 .woodmart-nav-link span')

$('<span class="mdi mdi-grid-large"></span>').insertBefore('#menu-item-1568657969810 .woodmart-nav-link span')

$('<span class="mdi mdi-weather-night-partly-cloudy"></span>').insertBefore('#menu-item-1568658016329 .woodmart-nav-link span')

$('<span class="mdi mdi-sofa"></span>').insertBefore('#menu-item-1595442393637 .woodmart-nav-link span')

$('<span class="mdi mdi-turtle"></span>').insertBefore('#menu-item-1595442393630 .woodmart-nav-link span')
                                                                 
// ##############################################################################

if ( window.location.href.includes('solicitar-un-proyecto') ) {
  $('.page-container h1').css({display: 'none'})
}

// none short-description
$('.shopify-product-details__short-description').css( "display", "none" )

// clone and write new short description
$('.price-box').after('<div id="new-description-code"></div>')
var clone = $('#tab-description .wc-tab-inner').clone()
$('#new-description-code').append(clone)

// none elements new description
$('#new-description-code').find('table').css( "display", "none" )
$('#new-description-code').find('iframe').css( "display", "none" )
// $('#new-description-code').find('h2').css( "display", "none" )

// none description description general
$('#tab-description .wc-tab-inner').find('ul').css( "display", "none" )
$('#tab-description .wc-tab-inner').find('h2').css( "display", "none" )
$('#tab-description .wc-tab-inner').find('p').css( "display", "none" )
$('#tab-description .wc-tab-inner').find('table p').css( "display", "inline-block" )


// styles new short description
$('#new-description-code').find('ul').css({
  "margin": "10px 0px 10px 20px"
})

$('#new-description-code').find('ul').attr('id', 'listaId')
$('#new-description-code').find('li').addClass('li-element')



// FOOTER IMG
const payment = [
  { name: 'kueski', img: '//duduk.mx/cdn/shop/t/66/assets/kueski.png?v=97384173425502201221690389035' },
  { name: 'visa', img: '//duduk.mx/cdn/shop/t/66/assets/visa.svg?v=182235949372009720551690389082' },
  { name: 'paypal', img: '//duduk.mx/cdn/shop/t/66/assets/paypal.svg?v=92996906437166178281690389058' },
  { name: 'amex', img: '//duduk.mx/cdn/shop/t/66/assets/amex.svg?v=43044405013328286631690388974' },
  { name: 'mastercard', img: '//duduk.mx/cdn/shop/t/66/assets/mastercard.svg?v=128126664307407055701690389045' },
]
   
$.each(payment, function(i, {name, img}) {
   $('.min-footer .col-right').append($('<img>', { 
   	src : img, 
 	alt : name, 
    title : 'paga con' + name,
  	class: 'f-element'
   }))
})

$('.total-line--shipping .order-summary__small-text').text('$0')

$('<div id="modal-colors" class="modal-colors"></div>').appendTo(document.body)
$('#modal-colors').prepend('<div id="content-modal"><div/>')
$('#content-modal').prepend('<div id="btn-content-modal">X<div/>')
$('#btn-content-modal').click(() => $('#modal-colors').removeClass('show-modal-colors'))
$('#content-modal').prepend('<img class="image-colors" src="//duduk.mx/cdn/shop/t/66/assets/colors-palet-v3.jpg?v=107748992659145170491690388991" />')

$('.modal-colors-btn').click(() => {
  $('#modal-colors').addClass('show-modal-colors')
})
  
function validateEmail(email) {
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

$(document).ready(function(){
  $('.woodmart-scroll-content li').each(function(){
    $(this).css('width', '80%')
  });
  
  
  // set alt images
  $.each($('img'), function(i, e) { 
  	if (!$(this).attr('alt')) {
  		$(this).attr('alt', 'imagen')
  	}
   })
  
  
  if ($('#product-main-form .tamaño select').length && window.location.href.includes('cama')) {
  
  	const list = []

    $('#product-variants .tamaño select option').each(function() {
      list.push($(this).val())
    })
  
    if (list.includes('Individual')) {
      $('#product-variants .tamaño select').val('Individual').change()
    }
  }
  
  /*
    ---------- newsletter ----------
  */

    // verificacion
  	const name = $('#n-name')
    const email = $('#n-email')
    const btn = $('#n-button')
    

    // send event
    btn.on('click', function (e) {

      e.preventDefault()
      
      
      
      	$('#news-error').css({'display': 'none' })
        
        // error
        if (!name.val().length || !validateEmail(email.val())) {
          $('#news-error').css({'display': 'block', 'color': 'red' })
          $('#news-error').text('Escriba su nombre y email correctamente')
          return true
       }
      
      $('.news-loader').css({'display': 'block'})
      
      const templateParams = {
        name: name.val(),
        email: email.val()
      }
       
      emailjs.send(emailSetting.SERVICE_ID, emailSetting.TEMPLATE_NEWSLETTER, templateParams)
        .then(function(response) {
          $('#news-error').css({'display': 'block', 'color': 'green' })
          $('#news-error').text('Datos enviados correctamente, gracias!')
          $('.news-loader').css({'display': 'none'})
        }, function(error) {
          $('#news-error').css({'display': 'block', 'color': 'red' })
          $('#news-error').text('Algo fallo en la solicitud, por favor intentelo mas tarde')
          $('.news-loader').css({'display': 'none'})
        })
      
     })

     /*
    ----------  end newsletter ----------
    */
    

    /* ----------------- icons + mobile --------------*/
    
    $('.icon-sub-menu').prepend('<span class="mdi mdi-plus"></span>')
    
    $('.icon-sub-menu').click(function(){

      if (!$(this).hasClass('up-icon')) {
      	
        $($(this).children('.mdi')[0]).css('transform', 'rotate(225deg)')
        
        return true
      }
      
      $($(this).children('.mdi')[0]).css('transform', '')
      
    })
    
    $('.mobile-menu-collections .icon-sub-menu').click(function(e) {
      const element = document.getElementById('menu-collections-box')
      
      if (!element.style.height || element.style.height == '0px') {
        element.style.height = Array.prototype.reduce.call(element.childNodes, function(p, c) {return p + (c.offsetHeight || 0);}, 0) + 'px';
      } else {
        element.style.height = '0px';
      }
    })



    /*
    ---------- zip_modal ----------
    */
  
  const modal_email = $('#zip_email')
  const modal_entry = $('#zip_entry')
  const modal_error = $('#zip_error')
  const zip_error_zip = $('#zip_error_zip')

  const sectionModal = (modal, zip) => {
    modal_email.css('display', 'none')
    modal_entry.css('display', 'none')
    modal_error.css('display', 'none')

    if (modal === 'email') {
      modal_email.css('display', 'block')
    }

    if (modal === 'entry') {
      modal_entry.css('display', 'block')
    }

    if (modal === 'error') {
      modal_error.css('display', 'block')
      zip_error_zip.text(zip)
    }
  }

  // zip
  const zipCodes = [
    { a: 01, b: 16, city: 'Ciudad de México' },
    { a: 50, b: 57, city: 'Estado de México' },
    { a: 64, b: 67, city: 'Nuevo León' },
    { a: 44, b: 49, city: 'Jalisco' },
    { a: 76, b: 76, city: 'Querétaro' },
    { a: 42, b: 43, city: 'Hidalgo' },
    { a: 36, b: 37, city: 'Guanajuato' },
    { a: 72, b: 75, city: 'Puebla' },
    { a: 62, b: 62, city: 'Morelos' },
    { a: 39, b: 41, city: 'Guerrero' },
    { a: 58, b: 61, city: 'Michoacán' },
    { a: 28, b: 28, city: 'Colima' },
    { a: 90, b: 90, city: 'Tlaxcala' },
    { a: 78, b: 79, city: 'San Luis Potosí' },
    { a: 87, b: 89, city: 'Tamaulipas' },
    { a: 20, b: 20, city: 'Aguascalientes' },
    { a: 98, b: 99, city: 'Zacatecas' },
    { a: 63, b: 63, city: 'Nayarit' },
    { a: 91, b: 96, city: 'Veracruz' }
  ]

  const zipErrorMessage = (message) => $('#zip_error_message').text(message)

  const zipValid = {
    empty: function () {
      zipErrorMessage('Escribe un código postal')

      return false
    },
    length: function (zip) {
      if (zip.length === 5) {
        return true
      }

      zipErrorMessage('El código postal debe tener 5 dígitos')
      return false
    },
    city: function (zip) {
      const valid = zipCodes.filter(({ a, b, ciry }) => Number(zip.substr(0, 2) >= a && Number(zip.substr(0, 2)) <= b))

      if (valid.length) {
        const complete = valid[0]
        complete.zip = zip

        localStorage.setItem('zip_code_data', JSON.stringify(complete))
        return true
      }

      sectionModal('error', zip)
      return false
    }
  }

  const overlayGlobalAction = (action) => {
    const modal = $('#overlay_global')

    modal.css('display', action)
  }


  const zipButtonHeader = (zip) => {
    const zip_code_city = localStorage.getItem('zip_code_data') ? JSON.parse(localStorage.getItem('zip_code_data')).city : null

    if (!zip) {
      $('#zip-code-show').css('background', '#f28d59')
      $('#zip-code-value').text('Agregar CP')
      $('#zip-code-city-mobile').text('')

      $('#zip-code-value-mobile').text('Agregar CP')
      $('#zipcode_bar_mobile').removeClass('bg-orange')
      $('#zipcode_bar_mobile').addClass('bg-red')

      return true
    }

    $('#zip-code-show').css('background', '#f28d59')
    $('#zip-code-value').text(`CP ${zip} - Envío gratis`)
    $('#zip-code-city').text(zip_code_city)
    $('#zip-code-city-mobile').text(zip_code_city)

    $('#zip-code-value-mobile').text(`CP ${zip} - Envío gratis`)
    $('#zipcode_bar_mobile').removeClass('bg-red')
    $('#zipcode_bar_mobile').addClass('bg-orange')
  }

  const live = localStorage.getItem('showModalZip') ? JSON.parse(localStorage.getItem('showModalZip')).expires : -1
  const showInit = Number(new Date()) > live
  const zip_code = localStorage.getItem('zip_code_data') ? JSON.parse(localStorage.getItem('zip_code_data')).zip : null
  const emails_subs = localStorage.getItem('showEmailSubs') ? JSON.parse(localStorage.getItem('showEmailSubs')) : null

  const setTimeModal = () => {
    const live = {
      show: false,
      expires: Number(new Date()) + 30 * 24 * 60 * 60 * 1000
    }

    if (modal_email.css('display') === 'block') {
      const emails_subs = localStorage.getItem('showEmailSubs') ? JSON.parse(localStorage.getItem('showEmailSubs')) : null

      if (emails_subs) {
        const { subscribe } = emails_subs

        if (subscribe) {
          return true
        }
      }

      localStorage.setItem('showEmailSubs', JSON.stringify({ 
        subscribe: false,
        expires: live.expires
      }))

      return true
    }

    localStorage.setItem('showModalZip', JSON.stringify(live))
  }


  $('#zip_modal_to_sigin').click(setTimeModal())
  zipButtonHeader(zip_code)

  const openModalEmailSubs = () => {
    overlayGlobalAction('block')
    sectionModal('email')

    return true
  }

  if(emails_subs) {
    const { subscribe, expires } = emails_subs

    if (!subscribe && Number(new Date()) > expires) {
      openModalEmailSubs()
    }

  } else {
    openModalEmailSubs()
  }

  // if (!zip_code && showInit) {
    // setTimeModal()
    // zipButtonHeader(zip_code)
    // overlayGlobalAction('block')
    // zipButtonHeader(false)
  // } else {
    // zipButtonHeader(zip_code)
  // }

  $('#zip_exit').click(function () {
    setTimeModal()

    $('#zip_email_message').css('color', 'red').text(null)
    $('#zip_modal_input_email').val(null)

    $('#zip_modal_input').val(null)
    overlayGlobalAction('none')
    zipErrorMessage(null)
    sectionModal('entry')
    return true
  })

  $('#zip-code-show').click(() => overlayGlobalAction('block'))
  $('#zip-code-show-mobile').click(() => overlayGlobalAction('block'))

  // email modal - subscribe
  $('#zip_input_email').keypress((e) => {
    $('#error-email-message').text('')
  })

  $('#zip-modal-button-email').click((e) => {
    e.preventDefault()
    const email = $('#zip_input_email').val()
    console.log(email, validateEmail(email))

    if (!validateEmail(email)) {
      $('#error-email-message').text('Escriba un email válido por favor')
      return true
    }

    const templateParams = {
      name: 'Modal Home',
      email
    }

    $('#error-email-message').text('Enviado...').css({'color': 'green'})
     
    emailjs.send(emailSetting.SERVICE_ID, emailSetting.TEMPLATE_NEWSLETTER, templateParams)
      .then(function(response) {
        $('#error-email-message').text('¡Gracias! Pronto tendremos sorpresas para ti. :)')
        localStorage.setItem('showEmailSubs', JSON.stringify({ 
          subscribe: true,
          expires: null
        }))
      }, function(error) {
        $('#error-email-message').text('Error al enviar datos, intentalo mas tarde.').css({'color': 'red'})
      })
  })
  // zip modal - open/close
  $('#zip-modal-button').click((e) => {
    e.preventDefault()
    const zip = $('#zip_modal_input').val()

    if (!zip) {
      return zipValid.empty()
    }

    if (zip) {
      const validLength = zipValid.length(zip)

      if (!validLength) {
        return true
      }

      const validCity = zipValid.city(zip)

      if (!validCity) {
        return true
      }

      overlayGlobalAction('none')
      zipButtonHeader(zip)
    }

    return true
  })

  $('#zip_modal_input').focus(() => zipErrorMessage(null))

  $('#zip_modal_input_email').focus(() => ($('#zip_email_message').css('color', 'red').text(null)))

  // email request suport zipcode
  $('#zip-email').on('click', (e) => {
    e.preventDefault()
    const email = $('#zip_modal_input_email').val()
    const messsageError = $('#zip_email_message')

    if (!email) {
      messsageError.text('Escriba un email valido')
      return true
    }

    if (!validateEmail(email)) {
      messsageError.text('El email es invalido')
      return true
    }

    const templateParams = {
      email,
      zipcode: $('#zip_modal_input').val()
    }

    emailjs.send(emailSetting.SERVICE_ID, emailSetting.TEMPLATE_ZIPCODE, templateParams)
      .then(function () {
        console.log('mensaje enviado')
        messsageError.css('color', 'green')
        messsageError.text('Solicitud enviada, Gracias!')
      }, function (error) {
        console.log(error)
        messsageError.text('Error, intente mas tarde por favor')
      })

  })
    /*
    ---------- end zip_modal ----------
    */

    const renderNavigationImages = () => {
      const menu = $('#menu-main-navigation')
      const elements = []

      menu.children('.menu-item').each(function(i, e) {
        const submenu = $(this).children('.sub-menu-dropdown')[0]
        if(submenu) {
          elements.push(submenu)
        }
      })

      const size = Math.max.apply(Math, elements.map((e) => $(e).height()))

      elements.forEach((e, index) => {
        $($(e)[0]).addClass('menu-main-photo').css({ height: `${size}px` })

        // console.log($($(e)[0]).children('.sub-menu-dropdown').context)
      })

      $('head').append(`<style>.menu-main-photo:before{ width: ${size}px; height: ${size}px !important;}</style>`)

      // console.log(size, count, elements)
    }

    renderNavigationImages()
})


//DESCRIPCION



//AÑADIR ELEMENTO A LISTA

var ul = document.getElementById("listaId");
var li = document.createElement("li");
let liValue = document.createElement("span")
liValue.innerHTML = "Verifica el color del acabado haciendo <a style='cursor: pointer' id='clickeado'>click aquí</a>";
li.classList.add("li-element")
li.appendChild(liValue);
ul.appendChild(li);


let modal = document.getElementById("modalCustom");
let span = document.getElementsByClassName("close")[0];
let boton = document.getElementById("clickeado");
console.log(boton)
boton.addEventListener("click", function() {
  modal.style.display = "block";
  span.onclick = function(){
    modal.style.display = "none";
  }
});








